import {useEffect, useState} from "react";
import '../../../static/css/home/gallery.css';
import {ServerImage} from "../../../components/api/webservice";
import {ThinPlayFillIcon} from "../../../components/icons/material-icons";

export interface galleryItemInterface {
    title: string,
    isVideo: boolean,
    poster: string,
    video: string,
    showVideo: boolean,
}

export const HomeGalleryScreen = () => {
    const [list, setList] = useState<galleryItemInterface[]>([
        {
            title: 'تبریک سال نو توسط کادر نهال',
            isVideo: true,
            poster: '1404.jpg',
            video: 'https://video.nahalmaharat.ir/1404.mp4',
            showVideo: false,
        },
        {
            title: 'جلسه انجمن اولیا در هتل پارادایس',
            isVideo: true,
            poster: 'anjoman.jpg',
            video: 'https://video.nahalmaharat.ir/anjoman.mp4',
            showVideo: false,
        },
        {
            title: 'نه به تصادفات جاده ای',
            isVideo: true,
            poster: 'tasadof.jpg',
            video: 'https://video.nahalmaharat.ir/tasadof.mov',
            showVideo: false,
        },
        {
            title: 'نقشه گنج و جشن ضرب',
            isVideo: true,
            poster: 'gold.jpg',
            video: 'https://video.nahalmaharat.ir/gold.mov',
            showVideo: false,
        },
        {
            title: 'تبریک سال نو دخترهای نهال',
            isVideo: true,
            poster: 'noroz.jpg',
            video: 'https://video.nahalmaharat.ir/noroz.mp4',
            showVideo: false,
        },
        {
            title: 'چهارشنبه سوری در نهال',
            isVideo: true,
            poster: 'charshanbe-sori.jpg',
            video: 'https://video.nahalmaharat.ir/charshabe-sori.mp4',
            showVideo: false,
        },
        {
            title: 'آموزش زبان همراه با بازی',
            isVideo: true,
            poster: 'english.jpg',
            video: 'https://video.nahalmaharat.ir/english.mp4',
            showVideo: false,
        },
        {
            title: 'تمرین جدول ضرب همراه با بازی',
            isVideo: true,
            poster: 'zarb.jpg',
            video: 'https://video.nahalmaharat.ir/zarb.mp4',
            showVideo: false,
        },
        {
            title: 'ریتم و گیم',
            isVideo: true,
            poster: 'game2.jpg',
            video: 'https://video.nahalmaharat.ir/game2.mp4',
            showVideo: false,
        },
        {
            title: 'ایران این ریشه من 🩷',
            isVideo: true,
            poster: 'iran.jpg',
            video: 'https://video.nahalmaharat.ir/iran.mp4',
            showVideo: false,
        },
        {
            title: 'چالش Compound Words با نهالی‌ها 😍',
            isVideo: true,
            poster: 'compound-words.jpg',
            video: 'https://video.nahalmaharat.ir/compound-words.mp4',
            showVideo: false,
        },
        {
            title: 'موسیقی کودک (ارف)',
            isVideo: true,
            poster: 'mosighi-kodak.jpg',
            video: 'https://video.nahalmaharat.ir/mosighi-kodak.mp4',
            showVideo: false,
        },
        {
            title: 'روز مادر مبارک',
            isVideo: true,
            poster: 'mothers-day.jpg',
            video: 'https://video.nahalmaharat.ir/mothers-day.mp4',
            showVideo: false,
        },
        {
            title: 'کف شب یلدا 🍉',
            isVideo: true,
            poster: 'kaf.jpg',
            video: 'https://video.nahalmaharat.ir/kaf.mp4',
            showVideo: false,
        },
        {
            title: 'طلا و جواهر در مدرسه',
            isVideo: true,
            poster: 'kardasti.jpg',
            video: 'https://video.nahalmaharat.ir/kardasti.mp4',
            showVideo: false,
        },
        {
            title: 'از اصول تربیت محرومیت مصلحتی است',
            isVideo: true,
            poster: 'bil.jpg',
            video: 'https://video.nahalmaharat.ir/bil.mp4',
            showVideo: false,
        },
        {
            title: 'جشن قرآن',
            isVideo: true,
            poster: 'quran.jpg',
            video: 'https://video.nahalmaharat.ir/quran.mp4',
            showVideo: false,
        },
        {
            title: 'هفته کتاب و کتابخوانی گرامی باد🌹',
            isVideo: true,
            poster: 'phone-vs-book.jpg',
            video: 'https://video.nahalmaharat.ir/phone-vs-book.mov',
            showVideo: false,
        },
        {
            title: 'به مناسبت هفته کتاب و کتابخوانی',
            isVideo: true,
            poster: 'book.jpg',
            video: 'https://video.nahalmaharat.ir/book.mp4',
            showVideo: false,
        },
        {
            title: 'بازارچه دانش‌آموزی',
            isVideo: true,
            poster: 'market.jpg',
            video: 'https://video.nahalmaharat.ir/market.mp4',
            showVideo: false,
        },
        {
            title: 'کارگاه مهارت آموزی آشپزی',
            isVideo: true,
            poster: 'ashpazi.jpg',
            video: 'https://video.nahalmaharat.ir/ashpazi.mp4',
            showVideo: false,
        },
    ]);
    useEffect(() => {
        document.title = "گالری | مدرسه هوشمند نهال";
    }, []);
    return (
        <>
            <div style={{background: '#fff'}}>
                <div className="container">
                    <div className="gallery-title">
                        <div>
                            <i/>
                            <em/>
                            <h1>گالری نهال</h1>
                        </div>
                    </div>
                    <div className="row">
                        {
                            list.map((m, i) =>
                                <div className="col-lg-4 col-6" key={"K8d_sjSjX" + i}>
                                    <div className="gallery-item">
                                        {
                                            m.showVideo ?
                                                <video src={m.video}
                                                       controls={true}
                                                       autoPlay={true}
                                                       poster={ServerImage(m.poster)}
                                                />:
                                                <>
                                                    <i style={{backgroundImage: `url(${ServerImage(m.poster)})`}}/>
                                                    <button onClick={()=>setList(v=>{
                                                        let x = [...v];
                                                        x[i].showVideo = true;
                                                        return x;
                                                    })}>
                                                        <ThinPlayFillIcon/>
                                                    </button>
                                                </>
                                        }
                                        <b>{m.title}</b>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
};